'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _buttons = require('@sitebase/ui-kit/es/buttons');

var _containers = require('../../containers');

var _iconsComponents = require('../../icons-components');

var _constants = require('../../constants');

var _currencySignFormatter = require('../../utils/currencySignFormatter');

require('./animated-success-message.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * AnimatedSuccessMessage component.
 * @param {Function} t the translator function
 * @param {Object} statusMessage the deposit status message
 * @returns {ReactElement} React element
 */
var AnimatedSuccessMessageComponent = function (_Component) {
  (0, _inherits3.default)(AnimatedSuccessMessageComponent, _Component);

  function AnimatedSuccessMessageComponent() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, AnimatedSuccessMessageComponent);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = AnimatedSuccessMessageComponent.__proto__ || (0, _getPrototypeOf2.default)(AnimatedSuccessMessageComponent)).call.apply(_ref, [this].concat(args))), _this), _this.digits = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9], _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(AnimatedSuccessMessageComponent, [{
    key: 'onAnimationEnd',

    /**
     * Replaces animated element with static ones
     * @param  {Event} event the animation end event
     * @return {Void}  void
     */
    value: function onAnimationEnd(event) {
      [].concat((0, _toConsumableArray3.default)(event.target.children)).forEach(function (el) {
        return el.classList.toggle('hidden');
      });
      event.target.classList.add('static');
      //NOTE: end-0 to end-9 are removed to keep compatibility with IE
      var classesToRemove = this.digits.map(function (x, y) {
        return 'end-' + y;
      });
      classesToRemove.push('animated');
      classesToRemove.map(function (className) {
        return event.target.classList.remove(className);
      });
    }

    /**
     * [addDigit description]
     * @param {[type]} from [description]
     * @param {[type]} to   [description]
     * @param {[type]} idx  [description]
     * @return {element} digit element
     */

  }, {
    key: 'addDigit',
    value: function addDigit(from, to, idx) {
      var _this2 = this;

      if (to === undefined) {
        return null;
      }

      return this.digits.indexOf(parseInt(to, 10)) < 0 ? _react2.default.createElement(
        'ul',
        { key: 's' + idx, className: 'digits static' },
        _react2.default.createElement(
          'li',
          { key: (idx || 0) + '-' + to },
          to
        )
      ) : _react2.default.createElement(
        'ul',
        {
          key: 'a' + idx,
          className: 'digits animated start-' + from + ' end-' + to,
          onAnimationEnd: function onAnimationEnd(event) {
            return _this2.onAnimationEnd(event);
          }
        },
        this.digits.map(function (digit) {
          return _react2.default.createElement(
            'li',
            { key: 'a' + idx + '-' + digit },
            digit
          );
        }),
        this.digits.map(function (digit) {
          return digit === Number(to) && _react2.default.createElement(
            'li',
            { className: 'hidden', key: 't' + idx + '-' + digit },
            digit
          );
        })
      );
    }

    /**
     * adds balance digits to be animated
     * @param {string} value value
     * @param {string} amount amount
     * @return {element} digits element
     */

  }, {
    key: 'addDigits',
    value: function addDigits(value, amount) {
      var _this3 = this;

      if (!value || !amount) {
        return null;
      }

      /**
       * retrieves a random digit between 0 and 9 not equals to digit
       * @param  {int} digit comparing digit
       * @return {int} a number in [0..9] different of digit
       */
      var getRandomDigit = function getRandomDigit(digit) {
        var random = -1;
        while (random < 0 || random === digit) {
          random = Math.floor(Math.random() * 10);
        }

        return random;
      };

      var newValue = Number(value).toFixed(2);
      var digits = newValue.split('').map(function (digit, idx) {
        return _this3.addDigit(getRandomDigit(Number(digit)), digit, idx + 1);
      });
      return digits;
    }
  }, {
    key: 'render',


    /**
     * Render method for the component
     * @returns {Element<*>} the react element
     */
    value: function render() {
      var _props = this.props,
          currencyCode = _props.currencyCode,
          onClose = _props.onClose,
          showDepositAgain = _props.showDepositAgain,
          _props$t = _props.t,
          t = _props$t === undefined ? function () {
        var ctx = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
        return function (msg) {
          return '' + ctx + msg;
        };
      } : _props$t;
      var _props$statusMessage = this.props.statusMessage,
          balance = _props$statusMessage.balance,
          depositAmount = _props$statusMessage.depositAmount,
          pmtId = _props$statusMessage.pmtId;


      return _react2.default.createElement(
        'div',
        { className: 'qd-success-screen__container' },
        _react2.default.createElement(
          'section',
          { className: 'qd-success-screen__panel' },
          _react2.default.createElement(
            'div',
            { className: 'qd-success-screen__panel__icon' },
            _react2.default.createElement(_iconsComponents.TrumpetIcon, null)
          ),
          _react2.default.createElement(
            'section',
            { className: 'qd-success-screen__message' },
            _react2.default.createElement(
              'h2',
              { className: 'qd-success-screen__message__title' },
              t(_constants.TRANSLATION_CONTEXT)('APP_SUCCESS_DEPOSIT_HEADER_TITLE')
            ),
            _react2.default.createElement(
              'div',
              { className: 'qd-success-screen__message__deposit-amount' },
              _react2.default.createElement(
                'span',
                { className: 'qd-success-screen__message__subtitle' },
                t(_constants.TRANSLATION_CONTEXT)('APP_SUCCESS_DEPOSIT_LINE_1')
              ),
              _react2.default.createElement(
                'h1',
                { className: 'qd-success-screen__message__amount' },
                (0, _currencySignFormatter.currencySignFormatter)(depositAmount || '0', currencyCode)
              )
            ),
            !!pmtId && _react2.default.createElement(
              'div',
              { className: 'qd-success-screen__message__payment-reference' },
              _react2.default.createElement(
                'span',
                { className: 'qd-success-screen__message__subtitle' },
                t(_constants.TRANSLATION_CONTEXT)('APP_SUCCESS_DEPOSIT_TRANSACT_REF')
              ),
              _react2.default.createElement(
                'span',
                { className: 'qd-success-screen__message__reference-no' },
                pmtId
              )
            ),
            !!balance && _react2.default.createElement(
              'div',
              { className: 'qd-success-screen__message__balance' },
              _react2.default.createElement(
                'span',
                { className: 'qd-success-screen__message__subtitle' },
                t(_constants.TRANSLATION_CONTEXT)('APP_SUCCESS_DEPOSIT_BALANCE')
              ),
              _react2.default.createElement(
                'span',
                { className: 'qd-success-screen__message__animated-counter' },
                (0, _currencySignFormatter.currencySignFormatter)(this.addDigits(balance, depositAmount), currencyCode)
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'qd-success-screen__continue-to-wh' },
            _react2.default.createElement(
              _buttons.Button,
              { outfit: 'quaternary expanded', onClick: onClose },
              t(_constants.TRANSLATION_CONTEXT)('APP_SUCCESS_DEPOSIT_BTN')
            )
          ),
          showDepositAgain && _react2.default.createElement(
            'div',
            { className: 'qd-success-screen__deposit-again' },
            _react2.default.createElement(_containers.DepositAgainContainer, null)
          )
        )
      );
    }
  }]);
  return AnimatedSuccessMessageComponent;
}(_react.Component);

exports.default = AnimatedSuccessMessageComponent;